<template>
    <div class="box">
      <div class="loading-spinner-outer" v-if="loading">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
        </div>
      </div>
        <div class="box-content">
            <div class="flex-2xs mb-3 justify-end">
                <div class="pr-3-2xs pb-1 pb-0-2xs">
                    <a class="btn-primary" :href="`/company/${company_id}/address/create`">
                        Add New
                    </a>
                </div>
                <div>
                    <input type="text" placeholder="Search" class="form-control" v-model="search_query">
                </div>
            </div>
          <template v-if="!loading && total_count > 0">
            <table class="table_list">
                <thead>
                <tr>
                    <th>Line 1</th>
                    <th>Line 2</th>
                    <th>Town</th>
                    <th>County</th>
                    <th>Postcode</th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(address, index) in addresses">
                    <td>{{ address.line_1 }}</td>
                    <td>{{ address.line_2 }}</td>
                    <td>{{ address.town }}</td>
                    <td>{{ address.county }}</td>
                    <td>{{ address.postcode }}</td>
                    <td class="td_delete">
                      <a @click.stop.prevent="deleteAddress(address.id)" class="txt-danger cursor-pointer">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                    <td class="td_view">
                        <a :href='`/company/${company_id}/address/${address.id}`' class="txt-primary">
                            <i class="fa fa-eye"></i>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <template>
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                    class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} results found
                            </div>
                        </div>
                    </div>
                </div>
            </template>
          </template>
          <template v-if="!loading && total_count === 0">
            <strong>
              No Results Found
            </strong>
          </template>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'company_id',
      'logged_in_user',
    ],
    mounted() {
      this.loadAddresses();
    },
    data() {
      return {
        addresses: [],
        search_query: '',
        current_page: 1,
        total_count: 0,
        total_pages: 0,
        limit: 20,
        loading: true,
      }
    },
    methods: {
      loadAddresses: _.debounce(function() {
        axios.post('/company/loadAddresses', {
          page_number: this.current_page,
          search_query: this.search_query,
          limit: this.limit,
          company_id: this.company_id,
        }).then((response) => {
          this.addresses = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
          this.loading = false;
        });
      }, 250),
      prevPage() {
        this.current_page = this.current_page - 1;
        this.loadAddresses();
      },
      nextPage() {
        this.current_page = this.current_page + 1;
        this.loadAddresses();
      },
      deleteAddress(id) {
        Swal.fire({
          title: 'Are you sure you want to remove this address?',
          text: 'This action cannot be undone.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post('/company/delete-address', {
              'address_id': id,
            }).then((response) => {
              this.current_page = 1;
              this.loadAddresses();
              Swal.fire({
                title: 'Address Deleted',
                icon: 'success',
              });
            });
          }
        });
      },
    },
    watch: {
      search_query() {
        this.current_page = 1;
        this.loadAddresses();
      },
    },
  };
</script>
